"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNITS = exports.IkeUnit = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var DECIMAL = /^(\-)?((?:[1-9]\d*|0)(?:\.\d*)?|\.\d+)([eE][+-]?\d+)?$/;
var FEET_INCH = /^(-)?(\d+)'(?:[ ]?(\d+)")?$/;
var INCHES_IN_FEET = 12;
/** Utility to help working with Distances and Angles */
var IkeUnit = /** @class */ (function () {
    function IkeUnit() {
    }
    /**
     * Case sensitive search for unit type
     * @see IkeUnit.toUnitDistance
     */
    IkeUnit.isUnitDistance = function (unit) {
        return IkeUnit.UNITS[core_api_1.IkeUnitType.DISTANCE][unit.toLowerCase()] != null;
    };
    /** Case insensitive unit type search */
    IkeUnit.toUnitDistance = function (unit) {
        var searchUnit = unit.toLowerCase();
        if (IkeUnit.isUnitDistance(searchUnit)) {
            return searchUnit;
        }
        return null;
    };
    /** Add an additional unit to IkeUnit */
    IkeUnit.addUnit = function (unit) {
        var e_1, _a;
        var unitType = unit.type == null ? core_api_1.IkeUnitType.DISTANCE : unit.type;
        IkeUnit.UNITS[unitType][unit.unit] = unit;
        var localDisplay = IkeUnit.DISPLAY_TYPE[unitType];
        try {
            for (var _b = tslib_1.__values(unit.display), _c = _b.next(); !_c.done; _c = _b.next()) {
                var displayUnit = _c.value;
                localDisplay[displayUnit] = unit;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /** format a angle */
    IkeUnit.displayAngle = function (value, to, from, decimals) {
        return IkeUnit.display(value, to, from, core_api_1.IkeUnitType.ANGLE, decimals);
    };
    /** Format a area */
    IkeUnit.displayArea = function (value, to, from) {
        return IkeUnit.display(value, to, from, core_api_1.IkeUnitType.AREA);
    };
    /**
     * Format a value  into a human readable output
     * */
    IkeUnit.display = function (value, to, from, unitType, decimals) {
        if (unitType == null) {
            unitType = IkeUnit.getUnitType(to);
            if (unitType == null) {
                return '';
            }
        }
        if (decimals == null) {
            decimals = IkeUnit.DECIMALS;
        }
        if (from == null) {
            from = IkeUnit.getBaseType(unitType);
        }
        // Convert the value if required into the output value
        var actualValue = IkeUnit.convert(value, to, from, unitType);
        if (isNaN(actualValue)) {
            return '';
        }
        var unitConversions = IkeUnit.UNITS[unitType];
        var toConversion = unitConversions[to];
        // If the convertor provides a formatting function use it. (Feet/Inches)
        if (toConversion.format && unitType === core_api_1.IkeUnitType.DISTANCE) {
            return toConversion.format(actualValue, unitType);
        }
        return IkeUnit.toFixed(actualValue, decimals) + IkeUnit.getDisplay(to, unitType);
    };
    /** Convert a angle from one angle type to another angle type */
    IkeUnit.convertAngle = function (value, to, from) {
        return IkeUnit.convert(value, to, from, core_api_1.IkeUnitType.ANGLE);
    };
    IkeUnit.convertArea = function (value, to, from) {
        return IkeUnit.convert(value, to, from, core_api_1.IkeUnitType.AREA);
    };
    IkeUnit.getUnitType = function (type) {
        var e_2, _a;
        try {
            for (var UNITS_1 = tslib_1.__values(exports.UNITS), UNITS_1_1 = UNITS_1.next(); !UNITS_1_1.done; UNITS_1_1 = UNITS_1.next()) {
                var unit = UNITS_1_1.value;
                if (unit.unit === type) {
                    return unit.type;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (UNITS_1_1 && !UNITS_1_1.done && (_a = UNITS_1.return)) _a.call(UNITS_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return null;
    };
    /**
     * Convert a number from one unit to another
     * @param value value to convert
     * @param to unit type to convert to
     * @param from unit type to convert from
     * @param unitType Type of to and from
     */
    IkeUnit.convert = function (value, to, from, unitType) {
        if (isNaN(value) || typeof value !== 'number') {
            return NaN;
        }
        // Attempt to determine the base unit type for the to unit type
        if (unitType == null) {
            unitType = IkeUnit.getUnitType(to);
            if (unitType == null) {
                return NaN;
            }
        }
        // Assume the base type if no from is provided
        var baseType = IkeUnit.getBaseType(unitType);
        if (from == null) {
            from = baseType;
        }
        var unitConversions = IkeUnit.UNITS[unitType];
        // If the from is not the base type, convert into the base type first
        if (from !== baseType) {
            var fromConversion = unitConversions[from];
            if (fromConversion == null) {
                return NaN;
            }
            value = value * fromConversion.conversion;
        }
        var toConversion = unitConversions[to];
        if (toConversion == null) {
            return NaN;
        }
        // Convert into the output value
        return value / toConversion.conversion;
    };
    /** Get the display information for the unit, for example " for inches */
    IkeUnit.getDisplay = function (unit, unitType) {
        if (unitType === void 0) { unitType = core_api_1.IkeUnitType.DISTANCE; }
        var unitConversions = IkeUnit.UNITS[unitType];
        var type = unitConversions[unit];
        if (type == null) {
            return '';
        }
        if (Array.isArray(type.display)) {
            return type.display[0];
        }
        return type.display;
    };
    /** Get the base UnitType */
    IkeUnit.getBaseType = function (unitType) {
        if (unitType === void 0) { unitType = core_api_1.IkeUnitType.DISTANCE; }
        return IkeUnit.BASE_TYPE[unitType];
    };
    /**
     * Convert the string input into Distance
     *
     * @param input String value of distance.
     * @param unit Unit type to parse from.
     * @returns {number} Distance in Meters.
     */
    IkeUnit.parse = function (input, unit) {
        if (input == null) {
            return NaN;
        }
        var test = input.trim();
        if (test.length === 0) {
            return NaN;
        }
        var currentUnit, unitPortion;
        var unitMatches = test.match(/[^0-9]+$/);
        if (unitMatches) {
            unitPortion = unitMatches[0];
            var currentUnitObj = IkeUnit.DISPLAY_TYPE[core_api_1.IkeUnitType.DISTANCE][unitPortion];
            if (currentUnitObj != null) {
                currentUnit = currentUnitObj.unit;
            }
        }
        if (currentUnit) {
            test = test.substr(0, test.length - unitPortion.length);
        }
        else {
            currentUnit = unit;
        }
        var matches = test.match(DECIMAL);
        if (matches) {
            var sign = matches[1] == null ? 1 : -1;
            return sign * IkeUnit.convert(parseFloat(matches[2]), IkeUnit.METER, currentUnit);
        }
        return IkeUnit.parseFeetInch(input);
    };
    IkeUnit.getUnits = function (unitType) {
        return IkeUnit.UNITS[unitType];
    };
    // Better ToFixed implementation
    // @see http://stackoverflow.com/questions/10015027/javascript-tofixed-not-rounding
    IkeUnit.toFixed = function (num, precision) {
        return (+(Math.round(+(num + 'e' + precision)) + 'e' + -precision)).toFixed(precision);
    };
    /**
     * Round a number to the provided precision
     *
     * @param num Number to round
     * @param precision Number of decimal places to keep
     */
    IkeUnit.round = function (num, precision) {
        return (Math.round((num * Math.pow(10, precision)).toFixed(precision - 1)) / Math.pow(10, precision));
    };
    /** Split inches into feet and inches  */
    IkeUnit.splitFeetInch = function (inches) {
        /* tslint:disable:no-bitwise */
        return {
            feet: ~~(inches / INCHES_IN_FEET), // Truncate the remainder
            inches: inches % INCHES_IN_FEET
        };
        /* tslint:enable:no-bitwise */
    };
    /**
     * Join feet & inches into inches
     * @param feet Number of feet (Feet)
     * @param inches Number of inches (Inches)
     * @returns Total size (Inches)
     */
    IkeUnit.joinFeetInch = function (feet, inches) {
        return feet * INCHES_IN_FEET + inches;
    };
    /**
     * Format a number into feet and inches
     *
     * @param value value to convert
     * @param unitType Unit that value is in
     * @returns Value formatted in feet and inches (1' 6")
     */
    IkeUnit.formatFeetInch = function (value, unitType) {
        var inches = Math.round(IkeUnit.convert(value, IkeUnit.INCH, IkeUnit.FEET, unitType));
        var feetInches = this.splitFeetInch(inches);
        var display = "".concat(Math.abs(feetInches.feet), "'");
        if (value < 0) {
            display = "-".concat(display);
        }
        if (feetInches.inches !== 0) {
            return "".concat(display, " ").concat(Math.abs(feetInches.inches) + IkeUnit.getDisplay(IkeUnit.INCH, unitType));
        }
        return display;
    };
    /**
     * Attempt to parse Feet/Inches from a string
     *
     * @returns Parsed value or NaN (Meters)
     */
    IkeUnit.parseFeetInch = function (input) {
        var matches = input.match(FEET_INCH);
        if (matches == null) {
            return NaN;
        }
        // Feet and inches
        var sign = matches[1] == null ? 1 : -1;
        var feet = parseFloat(matches[2]);
        var inches = matches[3] ? parseFloat(matches[3]) : 0;
        if (inches > 11) {
            return NaN;
        }
        var feetM = IkeUnit.convert(feet, IkeUnit.METER, IkeUnit.FEET);
        var inchM = IkeUnit.convert(inches, IkeUnit.METER, IkeUnit.INCH);
        return (feetM + inchM) * sign;
    };
    // Distance
    IkeUnit.FEET = core_api_1.IkeUnitDistance.FEET;
    IkeUnit.METER = core_api_1.IkeUnitDistance.METER;
    IkeUnit.CENTIMETER = core_api_1.IkeUnitDistance.CENTIMETER;
    IkeUnit.MILLIMETER = core_api_1.IkeUnitDistance.MILLIMETER;
    IkeUnit.INCH = core_api_1.IkeUnitDistance.INCH;
    // Angles
    IkeUnit.RADIAN = core_api_1.IkeUnitAngle.RADIAN;
    IkeUnit.DEGREE = core_api_1.IkeUnitAngle.DEGREE;
    /** Default distance type to use */
    IkeUnit.DEFAULT = IkeUnit.METER;
    /** Default formatting length */
    IkeUnit.DECIMALS = 2;
    IkeUnit.UNITS = (_a = {},
        _a[core_api_1.IkeUnitType.ANGLE] = {},
        _a[core_api_1.IkeUnitType.DISTANCE] = {},
        _a[core_api_1.IkeUnitType.AREA] = {},
        _a);
    IkeUnit.DISPLAY_TYPE = (_b = {},
        _b[core_api_1.IkeUnitType.ANGLE] = {},
        _b[core_api_1.IkeUnitType.DISTANCE] = {},
        _b[core_api_1.IkeUnitType.AREA] = {},
        _b);
    /** Each unit type has a base type that all values are stored as */
    IkeUnit.BASE_TYPE = (_c = {},
        _c[core_api_1.IkeUnitType.ANGLE] = core_api_1.IkeUnitAngle.RADIAN,
        _c[core_api_1.IkeUnitType.DISTANCE] = core_api_1.IkeUnitDistance.METER,
        _c[core_api_1.IkeUnitType.AREA] = core_api_1.IkeUnitDistance.METER,
        _c);
    return IkeUnit;
}());
exports.IkeUnit = IkeUnit;
// Load the unit definitions.
exports.UNITS = [
    { unit: core_api_1.IkeUnitDistance.METER, conversion: 1, display: ['m'], label: 'Meters', type: core_api_1.IkeUnitType.DISTANCE },
    { unit: core_api_1.IkeUnitDistance.CENTIMETER, conversion: 0.01, label: 'Centimeters', display: ['cm'], type: core_api_1.IkeUnitType.DISTANCE },
    { unit: core_api_1.IkeUnitDistance.MILLIMETER, conversion: 0.001, display: ['mm'], type: core_api_1.IkeUnitType.DISTANCE },
    {
        unit: core_api_1.IkeUnitDistance.FEET,
        conversion: 0.3048,
        display: ['\'', 'ft', 'feet'],
        label: 'Feet/Inches',
        format: function (value, unitType) { return IkeUnit.formatFeetInch(value, unitType); },
        type: core_api_1.IkeUnitType.DISTANCE
    }, {
        unit: core_api_1.IkeUnitDistance.INCH,
        conversion: 0.0254,
        display: ['"', 'in'],
        label: 'Inches',
        type: core_api_1.IkeUnitType.DISTANCE
    },
    // Angle
    { unit: core_api_1.IkeUnitAngle.RADIAN, conversion: 1, display: ['rad'], type: core_api_1.IkeUnitType.ANGLE },
    { unit: core_api_1.IkeUnitAngle.DEGREE, conversion: Math.PI / 180, display: ['°'], type: core_api_1.IkeUnitType.ANGLE },
    // Area
    // TODO Area should not really share the same unit name as distance.
    { unit: core_api_1.IkeUnitDistance.METER, conversion: 1, display: ['m²'], type: core_api_1.IkeUnitType.AREA },
    { unit: core_api_1.IkeUnitDistance.CENTIMETER, conversion: 0.0001, display: ['cm²'], type: core_api_1.IkeUnitType.AREA },
    { unit: core_api_1.IkeUnitDistance.MILLIMETER, conversion: 1e-6, display: ['mm²'], type: core_api_1.IkeUnitType.AREA },
    { unit: core_api_1.IkeUnitDistance.INCH, conversion: 0.00064516, display: ['in²'], type: core_api_1.IkeUnitType.AREA },
    { unit: core_api_1.IkeUnitDistance.FEET, conversion: 0.09290304, display: ['ft²'], type: core_api_1.IkeUnitType.AREA }
];
exports.UNITS.forEach(function (u) { return IkeUnit.addUnit(u); });
//# sourceMappingURL=unit.js.map